import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { sendMessage } from '../services/api';
import { Form, Button, Modal } from "react-bootstrap";

const CreatedPage = () => {
  const { slug } = useParams();
  const [loading, setLoading] = useState(true);
  const [msgLoading, setMsgLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const [linkData, setLinkData] = useState(null);
  const [typeData, setTypeData] = useState(null);

  const [keyStatus, setKeyStatus] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const [successMessageVisible, setSuccessMessageVisible] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Get form values
    const name = document.getElementById("name").value;
    const email = document.getElementById("email").value;
    const message = document.getElementById("message").value;

    console.log(name,email,message,slug);
    
    setMsgLoading(true);

    try {
      const data = await sendMessage(name, email, message, slug);
      console.log(data);
      setSuccessMessageVisible(true);
        setTimeout(() => {
          window.location.href = "https://urqr.pro/";
        }, 5000);
    } catch (error) {
      if(error.response.data.error.email){
        alert("Failed to send the message. Please try again.");
      }else{
        alert("An error occurred. Please try again.");
      }
      
      setMsgLoading(false);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

  };

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token"); // Get the token from local storage

      try {
        setLoading(true); // Set loading to true while fetching data
        setError(null); // Reset any previous errors

        const url = token
          ? `https://urqr.urqr.pro/api/users/pages/created-page-${slug}`
          : `https://urqr.urqr.pro/api/pages/created-page-${slug}`;

        const response = await fetch(url, {
          method: "GET",
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await response.json();

        // Check conditions based on the response data
        if (data.message === "Not available") {
          setError("Link Not Active");
        } else if (data.message === "User is authenticated") {
          setLinkData(data.linkData); // Store the fetched data
          if(data.type){
            setTypeData(data.type);
          }
          setKeyStatus(data.linkData?.key_status === 1);
          setSuccess(true); // Mark the success flag
        } else if (data.message === "User form") {
          setSuccess(false); // Mark as form not submitted
        }
      } catch (error) {
        console.error("Error fetching data:", error.message);
        setError(error.message); // Store the error message
      } finally {
        setLoading(false); // Set loading to false after the request completes
      }
    };

    fetchData();
  }, [slug]);

  const handleSwitchChange = () => {
    setShowConfirm(true);
  };

  const handleConfirm = async () => {
    setShowConfirm(false);
    const newStatus = keyStatus ? 0 : 1;

    try {
      const payload = {
        key_status: newStatus,
        qr_code_id: linkData.id, // Assuming linkData contains the QR code ID
      };
      const token = localStorage.getItem("token");
      // API call to update key status
      const response = await fetch(`https://urqr.urqr.pro/api/users/update-key-status`, {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          Authorization: token ? `Bearer ${token}` : "",
        },
      });
      if (!response.ok) throw new Error("Failed to update key status");
      window.location.reload();
    } catch (error) {
      console.error("Error updating key status:", error.message);
      alert("Error updating key status.");
    }
  };

  // Render when there's an error
  if (error) {
    return (
      <div className="not-available-container">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          className="not-available-icon bi bi-link-45deg"
          viewBox="0 0 16 16"
        >
          <path d="M4.715 6.542a1 1 0 0 1 1.436-1.436l2 2a1 1 0 0 1-1.436 1.436l-2-2ZM8.39 1.228a3.5 3.5 0 0 1 4.95 4.95l-3.182 3.182a.5.5 0 0 1-.707 0l-2.829-2.83a.5.5 0 0 1 0-.707L8.39 1.228Zm.146.854-2.829 2.83a1.5 1.5 0 0 0 0 2.121l2.829 2.829a1.5 1.5 0 0 0 2.121 0l3.182-3.182a2.5 2.5 0 0 0-3.536-3.536l-2.767 2.767a.5.5 0 0 1-.707 0l-.854-.854a.5.5 0 0 1 0-.707l2.768-2.768ZM3.5 8a.5.5 0 0 1 .5.5v1.79l3.203 3.203a2.5 2.5 0 0 0 3.536-3.536l-2-2a.5.5 0 0 1 .707-.707l2 2a3.5 3.5 0 1 1-4.95 4.95L4 10.29v1.21a.5.5 0 0 1-1 0V8.5a.5.5 0 0 1 .5-.5Z" />
        </svg>
        <h3 className="fw-bold">Link Not Active</h3>
        <p className="text-muted">
          The link you are trying to access is no longer active or not available at the moment.
        </p>
      </div>
    );
  }

  // Render when link data is available
  if (linkData) {
    return (
        <div className="chat-form-container">
        <>
          <div className="chat-form-header">
            <h4>
              <i className="fas fa-comments"></i> QR code link id:{" "}
              <span>{slug}</span>
            </h4>
          </div>

          <div className="link-details-container">
            <h4 className="">Key Status</h4>
            <Form.Check
              type="switch"
              id="keyStatusSwitch"
              label={keyStatus ? "Key IN" : "Key OUT"}
              checked={keyStatus}
              onChange={handleSwitchChange}
            />

            {/* Confirmation Modal */}
            <Modal show={showConfirm} onHide={() => setShowConfirm(false)}>
              <Modal.Header closeButton>
                <Modal.Title>Confirm Action</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                Are you sure you want to update Key status : {keyStatus ? "OUT" : "IN"} ?
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowConfirm(false)}>
                  Cancel
                </Button>
                <Button variant="primary" onClick={handleConfirm}>
                  Yes, Proceed
                </Button>
              </Modal.Footer>
            </Modal>
            <p>
              <strong>Key Status Updated By:</strong> {linkData.last_updated_by}
            </p>
            {!typeData && (
              <>
                <h4 className="">Link Details</h4>
                <p>
                  <strong>Type:</strong> {linkData.type}
                </p>
                <p>
                  <strong>Email:</strong> {linkData.email}
                </p>
                <p>
                  <strong>Title:</strong> {linkData.title}
                </p>
              </>
            )}

            {linkData.identifier && (
              <p>
                <strong>Identifier:</strong> {linkData.identifier}
              </p>
            )}

            {!typeData && (
              <>
                <p>
                  <strong>Subject:</strong> {linkData.description}
                </p>

                {linkData.created_at && (
                  <p>
                    <strong>Created At:</strong> {new Date(linkData.created_at).toLocaleDateString()}
                  </p>
                )}

                {linkData.updated_at && (
                  <p>
                    <strong>Updated At:</strong> {new Date(linkData.updated_at).toLocaleDateString()}
                  </p>
                )}

                {linkData.image && (
                  <div style={{ marginTop: "1rem" }}>
                    <p><strong>Image:</strong></p>
                    <img
                      src={linkData.image}
                      alt="QR Code"
                      style={{ maxWidth: "100%", height: "auto", border: "1px solid #ccc", borderRadius: "8px" }}
                    />
                  </div>
                )}

              </>
            )}
          </div>
        </>
    </div>
    );
  }

  // Render chat form if not success or error
  if (loading) {
    return (
      <div className="loading-indicator">
        <span>Loading...</span>
      </div>
    );
  }

  // Render chat form if no link data and no error
  return (
    <div className="chat-form-container">
      {!success ? (
        <>
          <div className="chat-form-header">
            <h4>
              <i className="fas fa-comments"></i> QR code links to user id:{" "}
              <span>{slug}</span>
            </h4>
            <p>
              Use the form below to contact the user and remember to include your
              contact details.
            </p>
          </div>

          <div>
            {successMessageVisible ? (
              <div className="alert alert-success">Message sent successfully! Redirecting...</div>
            ) : (
              <form id="chatForm" className="chat-form" onSubmit={handleSubmit}>
                <input type="hidden" id="slug" value={slug} />

                {/* Name Field */}
                <div className="mb-3">
                  <label htmlFor="name" className="form-label">
                    Name (Optional)
                  </label>
                  <input type="text" className="form-control" id="name" placeholder="Enter your name" />
                </div>

                {/* Email Field */}
                <div className="mb-3">
                  <label htmlFor="email" className="form-label">
                    Email (Optional)
                  </label>
                  <input type="email" className="form-control" id="email" placeholder="Enter your email" />
                </div>

                {/* Message Field */}
                <div className="mb-3">
                  <label htmlFor="message" className="form-label">
                    Message *
                  </label>
                  <textarea
                    className="form-control"
                    id="message"
                    rows="4"
                    placeholder="Write your message here"
                    required
                  ></textarea>
                </div>

                {/* Submit Button */}
                <div className="d-grid mt-4">
                  <button type="submit" className="btn btn-primary" id="sendMessageButton" disabled={msgLoading}>
                    {msgLoading && (
                      <span
                        className="spinner-border spinner-border-sm"
                        id="loadingSpinner"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    )}
                    {msgLoading ? "Sending..." : "Send Message"}
                  </button>
                </div>
              </form>
            )}
          </div>
        </>
      ) : (
        <div className="success-message">
          <i className="fas fa-check-circle"></i>
          <h5 className="text-success mt-2">Your message has been sent!</h5>
        </div>
      )}
    </div>
  );
};

export default CreatedPage;
